module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "sticky-bora-webstore"
  }, [_c('header-view'), _vm._v(" "), _c('header2')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "125px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5921e0a2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/BasePage.vue
// module id = 281
// module chunks = 2